import { reduxForm, SubmissionError } from "redux-form/immutable";

import {
  fetchSignInMethodsForEmail,
  sendPasswordResetEmail as sendPasswordResetEmailFirebase
} from "services/firebase/auth";
import {
  InaccessibleEmailError,
  InvalidResetPasswordMethod
} from "services/firebase/auth/errors";
import firebaseErrorTranslator, {
  ErrorMessage
} from "services/firebase/auth/errorTranslator";
import { getFirstSSOProvider } from "services/firebase/auth/ssoProvider";

import {
  validateEmailLoosely,
  validateEmailStrictly
} from "seneca-common/utils/functions/validationFunctions";

import { sendPasswordResetEmail } from "features/user";
import { emailSignInUnavailable } from "features/user/actions/auth/signInWithEmailAndPassword";
import { getFirebaseEmail } from "features/user/utils/email";

import ResetPasswordForm from "../components/ResetPasswordForm";

const formName = "resetPassword";

const validate = (valuesIn: any) => {
  const { email } = valuesIn.toJS();
  return {
    email: validateEmailLoosely(email)
  };
};

const WrappedResetPasswordForm = reduxForm({
  form: formName,
  // @ts-ignore
  validate,
  onSubmit: async (
    formValues: Map<string, string>,
    dispatch: any,
    props: any
  ) => {
    const email = formValues.get("email") || "";

    try {
      if (validateEmailStrictly(email)) {
        const firebaseEmail = await getFirebaseEmail(email);
        await sendPasswordResetEmailFirebase(firebaseEmail);
        throw new InaccessibleEmailError();
      }

      const signInMethods = await fetchSignInMethodsForEmail(email);

      if (emailSignInUnavailable(signInMethods)) {
        const signInProvider = getFirstSSOProvider(signInMethods);
        throw new InvalidResetPasswordMethod(signInProvider);
      }

      await dispatch(sendPasswordResetEmail(email));
      return;
    } catch (err: any) {
      throw new SubmissionError<{}, ErrorMessage>({
        _error: firebaseErrorTranslator(err)
      });
    }
  },
  onSubmitSuccess: (result, dispatch, props: any) => {
    const { onEmailSubmitSuccess } = props;
    onEmailSubmitSuccess && onEmailSubmitSuccess();
  }
  // @ts-ignore
})(ResetPasswordForm);

export default WrappedResetPasswordForm;
